module.exports = __webpack_public_path__ + "img/cardiogram.f1bc90e6.svg";